var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',_vm._l((_vm.tabs),function(tab,i){return _c('AnemicButton',{key:tab.title,staticClass:"tab-button mr-5",class:{ active: _vm.selectedTabIndex === i },attrs:{"tile":""},on:{"click":function($event){return _vm.$emit('update:selectedTabIndex', i)}}},[_vm._v(" "+_vm._s(tab.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }